import Api from '../api';
const { axios: api } = Api;
const PREFIX = 'password-restart';

export const verifyPasswordRestartToken = async (token) => {
	const { data } = await api.get(`/${PREFIX}/verify/${encodeURIComponent(token)}`);
	return data;
};

export const requestPasswordRestart = async (payload) => {
	const { data } = await api.post(`/${PREFIX}/request`, payload);
	return data;
};

export const completePasswordRestart = async (payload) => {
	const { data } = await api.post(`/${PREFIX}/complete`, payload);
	return data;
};
